import {Avatar, Button, Menu, MenuItem} from '@mui/material'
import React from 'react'
import {Vendedor} from "../../types/Vendedor";
import Stack from "react-bootstrap/Stack";
import clsx from "clsx";
const estilosBotoes = require('../../estilos/botoes.module.scss').default
import './PerfilButton.scss'

export type PerfilButtonProps = {
    vendedorLogado: Vendedor
    onLogoutClick: () => void
}

export const PerfilButton = (props: PerfilButtonProps) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogout = () => {
        props.onLogoutClick()
        handleClose()
    }

    return (
        <>{props.vendedorLogado && props.vendedorLogado.Codigo && 
        <div style={{width: "100%"}}>
            <Button
                id="composition-button"
                aria-controls={open ? 'composition-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                accessKey="x"
                title="Clique aqui para desconectar o vendedor - Tecla de atalho [X]"
                onClick={handleClick}
                className={clsx(estilosBotoes.botaoIcone, 'no-global-button', 'button-perfil')}
                style={{maxHeight: "58px"}}
            >
                <Stack>
                    <Avatar />
                </Stack>
                <span style={{
                    marginLeft: "5px",
                    color: props.vendedorLogado?.GerenciaOutrosVendedores ? "var(--mu-azul-marcador, blue)" : undefined,
                    }}>
                    {`${props.vendedorLogado?.Nome} - ${props.vendedorLogado?.Codigo}`}
                </span>
            </Button>

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                // Migração MUI v4 -> v9: `MenuListProps` saiu em favor de `slotProps.list`.
                slotProps={{
                    list: { 'aria-labelledby': 'basic-button' },
                }}
                className="dropdown-perfil"
            >
                <MenuItem className="menu-item-perfil-button" onClick={handleLogout}>Sair</MenuItem>
            </Menu>
        </div>
        }</>
    );
}
